import common from './locales/common';
import entry from './locales/entry';
import index from './locales/index';
import barcode from './locales/barcode';
import ultrasound from './locales/ultrasound';
import tab from './locales/tab';
import points from './locales/points';
import reward from './locales/reward';
import coupons from './locales/coupons';
import brand from './locales/brand';
import profile from './locales/profile';
import datepicker from './locales/datepicker';
import picker from './locales/picker';
import draw from './locales/draw';
import transactions from './locales/transactions';
import claim from './locales/claim';
import trialCoupon from './locales/trial-coupon';
import stock from './locales/stock';
import gifts from './locales/gifts';
import edit from './locales/edit';
import news from './locales/news';
import promotions from './locales/promotions';

export default {
  en: {
    common: common.en,
    entry: entry.en,
    index: index.en,
    barcode: barcode.en,
    ultrasound: ultrasound.en,
    tab: tab.en,
    points: points.en,
    coupons: coupons.en,
    reward: reward.en,
    brand: brand.en,
    profile: profile.en,
    edit: edit.en,
    datepicker: datepicker.en,
    picker: picker.en,
    draw: draw.en,
    transactions: transactions.en,
    claim: claim.en,
    trialCoupon: trialCoupon.en,
    stock: stock.en,
    gifts: gifts.en,
    news: news.en,
    promotions: promotions.en,
  },
  'zh-Hant': {
    common: common['zh-Hant'],
    entry: entry['zh-Hant'],
    index: index['zh-Hant'],
    barcode: barcode['zh-Hant'],
    ultrasound: ultrasound['zh-Hant'],
    tab: tab['zh-Hant'],
    points: points['zh-Hant'],
    coupons: coupons['zh-Hant'],
    reward: reward['zh-Hant'],
    brand: brand['zh-Hant'],
    profile: profile['zh-Hant'],
    edit: edit['zh-Hant'],
    datepicker: datepicker['zh-Hant'],
    picker: picker['zh-Hant'],
    draw: draw['zh-Hant'],
    transactions: transactions['zh-Hant'],
    claim: claim['zh-Hant'],
    trialCoupon: trialCoupon['zh-Hant'],
    stock: stock['zh-Hant'],
    gifts: gifts['zh-Hant'],
    news: news['zh-Hant'],
    promotions: promotions['zh-Hant'],
  },
  vi: {
    common: common.vi,
    entry: entry.vi,
    index: index.vi,
    barcode: barcode.vi,
    ultrasound: ultrasound.vi,
    tab: tab.vi,
    points: points.vi,
    coupons: coupons.vi,
    reward: reward.vi,
    brand: brand.vi,
    profile: profile.vi,
    edit: edit.vi,
    datepicker: datepicker.vi,
    picker: picker.vi,
    draw: draw.vi,
    transactions: transactions.vi,
    claim: claim.vi,
    trialCoupon: trialCoupon.vi,
    stock: stock.vi,
    gifts: gifts.vi,
    news: news.vi,
    promotions: promotions.vi,
  },
  th: {
    common: common.th,
    entry: entry.th,
    index: index.th,
    barcode: barcode.th,
    ultrasound: ultrasound.th,
    tab: tab.th,
    points: points.th,
    coupons: coupons.th,
    reward: reward.th,
    brand: brand.th,
    profile: profile.th,
    edit: edit.th,
    datepicker: datepicker.th,
    picker: picker.th,
    draw: draw.th,
    transactions: transactions.th,
    claim: claim.th,
    trialCoupon: trialCoupon.th,
    stock: stock.th,
    gifts: gifts.th,
    news: news.th,
    promotions: promotions.th,
  },
};
